import {
  Button,
  Select,
  SelectOption,
  TextInput,
} from "@wearewqa/wqa-design-system";
import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Modal } from "../components/Modal/Modal";
import { getStores } from "../resources/stores";
import { createBeta } from "../resources/betas";
import { FileInput } from "../components/FileInput";
import { Heading } from "../components/Heading";
import { Spinner } from "../components";

type CreateBetaModalProps = {
  isOpen: boolean;
  onClose: () => void;
  appId: string;
};

type CreateBetaFormData = {
  version_number: string;
  display_name: string | null;
  store_id: string;
  app_id: string;
};

export const CreateBetaModal = ({
  appId,
  isOpen,
  onClose,
}: CreateBetaModalProps) => {
  const [stores, setStores] = useState<SelectOption[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [formData, setFormData] = useState<CreateBetaFormData>({
    version_number: "",
    display_name: null,
    store_id: "",
    app_id: appId,
  });

  function onFileChange(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  }

  function onInputChange(key: string, value: string) {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  }

  async function manageFormSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsLoading(true);
    if (!file) {
      throw new Error("File is missing. Please add a file.");
    }

    try {
      const beta = await createBeta(formData, file);
      if (beta) {
        console.log(
          `Success. Beta '${beta.display_name || beta.version_number}' has been created.`
        );
        window.location.reload();
      }
      setIsLoading(false);
    } catch (error) {
      console.error("AdminBetaForm - ManageFormSubmit: ", error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function buildData() {
      try {
        const storesData = await getStores();

        const storeSelectOptions: SelectOption[] = storesData.body.map(
          (current) => ({
            label: current.name,
            value: current.id as string,
          })
        );

        setStores(storeSelectOptions);
      } catch (error) {
        console.error("AdminBetaForm - buildData: ", error);
      }
    }

    void buildData();
  }, []);

  return (
    <Modal {...{ isOpen, onClose }}>
      <div className="create-beta-modal">
        <Heading label={"Upload a new Beta"} type={"h2"} />
        <br />
        <form className="modal-form" onSubmit={(e) => void manageFormSubmit(e)}>
          {stores !== null && (
            <>
              <div className="modal-form__store-inputs">
                <Select
                  required
                  id={"beta_form__stores"}
                  label={"Select an store."}
                  options={stores}
                  value={formData.store_id}
                  onChange={(e) => onInputChange("store_id", e)}
                />
              </div>

              <TextInput
                required
                id={"beta_form__name"}
                label={"Version Number"}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  onInputChange("version_number", event.target.value)
                }
              />

              <TextInput
                id={"beta_form__name"}
                label={"Display Name"}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  onInputChange("display_name", event.target.value)
                }
              />

              <FileInput
                id={"beta_form__file"}
                label={"Upload beta file."}
                onChange={onFileChange}
              />

              {!isLoading ? (
                <Button label={"Submit"} type="submit" />
              ) : (
                <Spinner />
              )}
            </>
          )}
        </form>
      </div>
    </Modal>
  );
};
